import { type HttpClient } from '@/application/interfaces/http-client';

import { getCrossesServices } from './get-crosses-services';

const CrossesService = (httpClient: HttpClient.Instance) => ({
  getCrossesServices: getCrossesServices(httpClient),
});

export default CrossesService;
